module.exports = __webpack_public_path__ + "img/receipt29.0fe6bdce.svg";